import axios from "axios";
import QS from "qs";

export default {
    // eslint-disable-next-line no-unused-vars
    SET_getAllRewards: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getAllRewards',
        }
        try {
            const response = await axios.post(urlRequest, QS.stringify(dataRequest));
            const result = response.data.result.entry_list
            let pushRewardsItem = []
            for (let key = 0; key < result.length; ++key) {
                pushRewardsItem[key] = {
                    url: context.rootGetters["settingsAndCustomize/configurationSite"].urlSite
                        + 'img/rewards/rewards_'
                        + result[key].name_value_list.note_id_c.value
                        + '_' + context.rootGetters['settingsAndCustomize/hash']
                        + '.jpg',
                    name: result[key].name_value_list.name.value,
                    category: result[key].name_value_list.category.value,
                    points: result[key].name_value_list.points.value,
                    description: result[key].name_value_list.description.value,
                    isDonation: result[key].name_value_list.is_donation.value,
                    idReward: result[key].name_value_list.id.value,
                }
            }
            context.commit('set_recordRewords', pushRewardsItem)
            return pushRewardsItem
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getRewardsSettings: (context) => {
        context.commit('set_authDonor', false)
    },
    SET_setRewardsOrder: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const description = 'Baer Name:     ' + context.rootGetters["donorInformation/firstName"] + ' ' + context.rootGetters["donorInformation/lastName"] + '\r\n' +
            'Reward Value   ' + context.rootGetters["rewards/selectedRewards"].points + ' POINTS \r\n' +
            'Description    ' + context.rootGetters["rewards/order"].personalMessage
        const dataRequest = {
            action: 'setRewardsOrder',
            module_name: 'Donor_RewardsOrders',
            donor_id_c: context.rootGetters["donorInformation/idDonor"],
            points: context.rootGetters["rewards/selectedRewards"].points,
            reward_id_c: context.rootGetters["rewards/selectedRewards"].idReward,
            description: description,
            reward_code: Math.floor(1000000000000000 + Math.random() * 9000000000000000),
            name: context.rootGetters["donorInformation/firstName"] + ' - REWARD'
        }
        try {
            await axios.post(urlRequest, QS.stringify(dataRequest))
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getRewardsOrders: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getRewardsOrders',
        }
        try {
            return await axios.post(urlRequest, QS.stringify(dataRequest));
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
}
